module.exports = __webpack_public_path__ + "static/img/SHAUN_TAIT.b387987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SHAUN_TAIT.jpg
// module id = 0CYp
// module chunks = 0